import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:id([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})',
    component: () => import('@/views/Radar.vue'),
    children: [
      {
        path: '',
        component: () => import('@/views/Gmap.vue'),
        children: [
          {
            path: '',
            name: 'markers',
            component: () => import('@/views/Markers.vue'),
          },
          {
            path: 'location/:location',
            name: 'location',
            component: () => import('@/views/Markers.vue'),
          },
          {
            path: 'division/:level/:key',
            name: 'division',
            component: () => import('@/views/Markers.vue'),
          },
          {
            path: 'zones',
            name: 'zones',
            component: () => import('@/views/Zones.vue'),
          },
          {
            path: 'zones/division/:level/:key',
            name: 'divisionZones',
            component: () => import('@/views/Zones.vue'),
          },
          {
            path: 'markers-intention',
            name: 'markersIntention',
            component: () => import('@/views/MarkersIntention.vue'),
          },
          {
            path: 'zones-intention',
            name: 'zonesIntention',
            component: () => import('@/views/ZonesIntention.vue'),
          },
          {
            path: 'zones-intention/division/:level/:key',
            name: 'divisionZonesIntention',
            component: () => import('@/views/ZonesIntention.vue'),
          },
        ],
      },
      {
        path: 'analytics',
        name: 'analytics',
        component: () => import('@/views/Analytics.vue'),
      },
    ],
  },
  {
    path: '/error',
    name: 'error-default',
    component: () => import('@/views/Error/Default.vue'),
    props: route => ({
      error: route.params.error,
    }),
  },
  { path: '*', name: 'error-404', component: () => import('@/views/Error/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  store.dispatch('radar/setCurrentRoute', to.name)
  if (to.query.view === 'lge_intention')
    return next({ name: 'zonesIntention', params: { ...to.params }, query: { locale: to.query.locale } })
  else next()
})

export default router
